import React from "react";

function InputField({input, className, placeholder, autoComplete, inputProps, disabled, meta: {touched, error, dirtySinceLastSubmit, submitError}}) {
    className = (touched && error) || (!dirtySinceLastSubmit && submitError) ? className+' control-error' : className;

    return <input
        {...input}
        {...inputProps}
        className={className}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
    />
}

export default InputField